var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 0.666687V2.00002H8.99998V0.666687H10.3333V2.00002H13C13.3682 2.00002 13.6666 2.2985 13.6666 2.66669V13.3334C13.6666 13.7016 13.3682 14 13 14H0.99998C0.631793 14 0.333313 13.7016 0.333313 13.3334V2.66669C0.333313 2.2985 0.631793 2.00002 0.99998 2.00002H3.66665V0.666687H4.99998ZM12.3333 7.33335H1.66665V12.6667H12.3333V7.33335ZM4.33331 8.66669V10H2.99998V8.66669H4.33331ZM7.66665 8.66669V10H6.33331V8.66669H7.66665ZM11 8.66669V10H9.66665V8.66669H11ZM3.66665 3.33335H1.66665V6.00002H12.3333V3.33335H10.3333V4.66669H8.99998V3.33335H4.99998V4.66669H3.66665V3.33335Z",
    fill: "#026094"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/calendar-blue.af2d71a734f21a958d7e1c3f99715818.svg";
export { ForwardRef as ReactComponent };